import { G } from '@mobily/ts-belt';
import { type ResourceOptions, useResourceDefinition, useTranslate } from 'react-admin';
import { Helmet, HelmetProps, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DEFAULT_PAGE_TITLE = 'Shares.io';

export const PageTitle = ({ title, ...rest }: HelmetProps) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get('page');

  const resource = useResourceDefinition<ResourceOptions>();
  const translate = useTranslate();

  const resolvedTitle =
    title ??
    (G.isNotNullable(resource.options?.label)
      ? translate(resource.options.label)
      : DEFAULT_PAGE_TITLE);

  const translatedTitle = currentPage
    ? translate('resources.bo_common.meta.page', { title: resolvedTitle, page: currentPage })
    : resolvedTitle;

  return (
    <HelmetProvider>
      <Helmet title={translatedTitle} {...rest} />
    </HelmetProvider>
  );
};
